import React from 'react'
import RootContainer from './root'
import { Provider } from 'react-redux';
import { createStore, compose, applyMiddleware, bindActionCreators } from 'redux';
import thunkMiddleware from 'redux-thunk';
import reducers from 'app/reducers';
import * as initialActions from './actions/initial_actions'
import * as constructionsActions from './actions/constructions_actions';
import * as orderActions from './actions/order_actions';

const store = createStore(reducers, undefined, compose(applyMiddleware(thunkMiddleware)));

class App extends React.Component{
  constructor(props) {
    super(props);
  }

  componentWillMount() {
    const { fetchSystemSettings } = bindActionCreators(initialActions, store.dispatch);
    const { fetchConstructions } = bindActionCreators(constructionsActions, store.dispatch);
    const { setDefaultOrderState } = bindActionCreators(orderActions, store.dispatch);
    fetchSystemSettings();
    fetchConstructions().then(() => setDefaultOrderState());
  }

  render() {
    return (
      <Provider store={store}>
        <RootContainer />
      </Provider>
    )
  }
}

export default App;




// WEBPACK FOOTER //
// ./app/javascript/app/index.jsx